import styled from "styled-components";

const Subtitle = styled.h2`
  font-size: 12px;
`;

export default Subtitle;
